import React, { useContext, useEffect, useState } from 'react';

import {
    Grid,
} from '@material-ui/core';

import { LogisticsForm } from './LogisticsForm'
import { LogisticsDocumentationForm } from './LogisticsDocumentationForm'
import { LogisticsCustomerServiceForm } from './LogisticsCustomerServiceForm'
import { LogisticsPlanningForm } from './LogisticsPlanningForm'

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { UserContext } from '../../../../contexts';

import { RequestStatus, ApplicationRoles } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: 20
    }
}));

export const LogisticsTab = (props) => {
    const classes = useStyles();

    const { 
        userInfo,
        isUserInRole, 
        isUserInRoles 
    } = useContext(UserContext);

    const {
        state
    } = useContext(CustomerRequestContext);

    const { 
        values,
        isSubmitting
    } = useContext(TabsContext);

    const [disabled, setDisabled] = useState(false);
    useEffect(() => {
        setDisabled(isSubmitting
            || !(
                (state.request.status === RequestStatus.Draft
                    && isUserInRole(ApplicationRoles.AOFOpener))
                ||
                (state.request.status === RequestStatus.Draft
                    && state.request.customerRequestId === 0
                    && isUserInRole(ApplicationRoles.BossApprover))
                ||
                (state.request.status === RequestStatus.ToBeReviewed
                    && state.request.ownerKey === userInfo.externalKey
                    && isUserInRole(ApplicationRoles.AOFOpener))
                ||
                (state.request.status === RequestStatus.AccountReceivableApproval
                    && isUserInRole(ApplicationRoles.AccountReceivable))
            )
        );
    }, [isSubmitting, state.request.status])    

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                {(state.request.status === RequestStatus.Logistic 
                    || state.request.status === RequestStatus.WaitingForContract
                    || state.request.status === RequestStatus.AccountReceivableApproval
                    || state.request.status === RequestStatus.WaitingToBeAddedInSap
                    || state.request.status === RequestStatus.Approved
                    || state.request.status === RequestStatus.CreditRiskReEvaluation) &&                    
                    <>
                        {(isUserInRoles([                            
                            ApplicationRoles.LogisticDocumentation, 
                            ApplicationRoles.AccountReceivable])

                            || (isUserInRole(ApplicationRoles.Administrator) && state.request.isLogisticDocumentationReady)) 
                            
                            && !values.isPerfumesCategory &&
                            
                            <Grid item xl={12} xs={12} md={12}>
                                <LogisticsDocumentationForm 
                                    disabled={
                                        
                                        isSubmitting 
                                        
                                        ||
                                        
                                        !(
                                            (state.request.status === RequestStatus.Logistic 
                                                && isUserInRole(ApplicationRoles.LogisticDocumentation)
                                                && !state.request.isLogisticDocumentationReady)
                                            
                                            || 
                                            
                                            (state.request.status === RequestStatus.AccountReceivableApproval
                                                && isUserInRole(ApplicationRoles.AccountReceivable))
                                        )
                                    } 
                                />
                            </Grid>
                        }
                        {(isUserInRoles([                            
                            ApplicationRoles.LogisticCustomerService,
                            ApplicationRoles.AccountReceivable])
                            
                            || (isUserInRole(ApplicationRoles.Administrator) && state.request.isLogisticCustomerServiceReady)) &&
                            
                            <Grid item xl={12} xs={12} md={12}>
                                <LogisticsCustomerServiceForm 
                                    disabled={

                                        isSubmitting

                                        || 

                                        !(
                                            (state.request.status === RequestStatus.Logistic 
                                                && isUserInRole(ApplicationRoles.LogisticCustomerService)
                                                && !state.request.isLogisticCustomerServiceReady)
                                            
                                            || 
                                            
                                            (state.request.status === RequestStatus.AccountReceivableApproval
                                                && isUserInRole(ApplicationRoles.AccountReceivable))
                                        )
                                    } 
                                />
                            </Grid>
                        }
                        {(isUserInRoles([                            
                            ApplicationRoles.LogisticPlanning,
                            ApplicationRoles.LogisticPlanningPerfumes,
                            ApplicationRoles.AccountReceivable])
                            
                            || (isUserInRole(ApplicationRoles.Administrator) && state.request.isLogisticPlanningReady)) &&

                            <Grid item xl={12} xs={12} md={12}>
                                <LogisticsPlanningForm 
                                    disabled={

                                        isSubmitting
                                        
                                        ||

                                        !(
                                            (state.request.status === RequestStatus.Logistic 
                                                && isUserInRoles([ApplicationRoles.LogisticPlanning, ApplicationRoles.LogisticPlanningPerfumes])
                                                && !state.request.isLogisticPlanningReady)
                                            
                                            || 
                                            
                                            (state.request.status === RequestStatus.AccountReceivableApproval
                                                && isUserInRole(ApplicationRoles.AccountReceivable))
                                        )                                        
                                    } 
                                />
                            </Grid>
                        }
                    </>
                }
                <Grid item xl={12} xs={12} md={12}>
                    <LogisticsForm disabled={disabled}/>
                </Grid>
            </Grid>
        </div>
    );
}


